import { render, staticRenderFns } from "./select-filter.vue?vue&type=template&id=860889b4&"
import script from "./select-filter.vue?vue&type=script&lang=js&"
export * from "./select-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports